<script setup lang="ts">
    import { computed } from 'vue';
    import type { InsightsBarListItem } from '../insights-theme';

    const props = defineProps<{
        items: InsightsBarListItem[];
        color: string;
    }>();

    const max = computed(() => Math.max(...props.items.map((i) => i.value), 1));
</script>

<template>
    <ul class="list-unstyled m-xs-t m-xs-b">
        <!-- Keyed by rank so bars are reused and animate between values when the items change -->
        <li v-for="(item, index) in items" :key="index" class="insights-barlist-item" :title="item.href ? undefined : `${item.label}: ${item.displayValue}`">
            <div class="d-flex justify-content-between align-items-baseline gap-sm">
                <span class="insights-barlist-label text-overflow-ellipsis text-nowrap">
                    <span v-if="item.flag" class="flag-icon m-xs-r" :class="`flag-icon-${item.flag.toLowerCase()}`"></span>
                    <a
                        v-if="item.href"
                        v-tooltip.top="item.href"
                        :href="item.href"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="insights-barlist-label d-flex align-items-center gap-xxs">
                        <span class="text-overflow-ellipsis text-nowrap">{{ item.label }}</span>
                        <svg
                            class="flex-shrink-0"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true">
                            <path d="M15 3h6v6" />
                            <path d="M10 14 21 3" />
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                        </svg>
                    </a>
                    <template v-else>{{ item.label }}</template>
                    <span v-if="item.sublabel" class="text-sm m-xs-l">{{ item.sublabel }}</span>
                </span>
                <span class="fw-600 text-nowrap">{{ item.displayValue }}</span>
            </div>
            <div class="insights-track insights-track-thin d-block round m-xs-t">
                <div class="insights-track-fill d-block" :style="{ width: `${(item.value / max) * 100}%`, background: color }"></div>
            </div>
        </li>
    </ul>
</template>

